import { HttpContextToken } from '@angular/common/http';

export const BYPASS_SERVER_ERROR_INTERCEPTOR = new HttpContextToken<boolean>(() => false);
export const BYPASS_AUTH_HEADER = new HttpContextToken<boolean>(() => false);
